import "../semantic/semantic";
import { IComponent } from "./IComponent";
import { PageState } from "../services";

export class LocaleSelectorComponent implements IComponent {

    cookieName: string;
    pageState: PageState;

    attach(element: Element, pageState: PageState, previousState: any) {
        
        this.cookieName = element.getAttribute("data-localeselector-cookie");
        this.pageState = pageState;
        $(element).dropdown({
            onChange: this.changed
        });
    }

    changed = (value, text, $choice) => {
        // console.log(value, text, $choice);
        this.pageState.bus.publish("locale.changed", null);
        if (value) {
            document.cookie = this.cookieName + "=c=" + value + "|uic=" + value + "; path=/; max-age=2630000";
        } else {
            document.cookie = this.cookieName + "=; path=/; max-age=-999999";
        }
        
        window.location.reload();
    };

    getState() {
        return null;
    }
}